import { __decorate, __metadata } from "tslib";
import { CacheActivePromise, Schedule } from '@1inch-community/core/decorators';
import { lazyAppContext } from '@1inch-community/core/lazy';
import { OneInchDevPortalCrossChainOnChainAdapter } from '../onchain';
import { PrivateProxyClient } from './private-proxy-client';
function ScheduleAccumulator(acc, value) {
    const chainIds = value[0];
    const accWalletAddresses = acc?.[1] ?? [];
    const walletAddresses = new Set([...accWalletAddresses, ...value[1]])
        .values()
        .toArray();
    return [chainIds, walletAddresses];
}
export class OneInchDevPortalCrossChainPrivateProxyAdapter {
    constructor() {
        this.context = lazyAppContext('OneInchDevPortalCrossChainPublicProxyAdapter');
        this.client = new PrivateProxyClient();
        this.fallBackAdapter = new OneInchDevPortalCrossChainOnChainAdapter();
    }
    async init(context) {
        this.context.set(context);
        await Promise.all([this.client.init(context), this.fallBackAdapter.init(context)]);
    }
    async getBalances(chainIds, walletAddresses) {
        return await this.client.post('/proxy/balance', {
            chain_ids: chainIds.map((chainId) => chainId.toString()),
            addresses: walletAddresses,
        });
    }
    async getTokenList() {
        const walletIsConnected = await this.walletIsConnected();
        if (!walletIsConnected) {
            return await this.fallBackAdapter.getTokenList();
        }
        try {
            return this.client.get('/proxy/token-list');
        }
        catch {
            return await this.fallBackAdapter.getTokenList();
        }
    }
    async getTokenPrice() {
        return this.client.get('/proxy/token-price');
    }
    getGasPrice() {
        throw new Error('Method not implemented.');
    }
    getProxyClient() {
        return this.client;
    }
    walletIsConnected() {
        return this.context.value.wallet.data.isConnected();
    }
}
__decorate([
    CacheActivePromise(),
    Schedule(50, ScheduleAccumulator),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Array]),
    __metadata("design:returntype", Promise)
], OneInchDevPortalCrossChainPrivateProxyAdapter.prototype, "getBalances", null);
__decorate([
    CacheActivePromise(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], OneInchDevPortalCrossChainPrivateProxyAdapter.prototype, "getTokenList", null);
__decorate([
    CacheActivePromise(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], OneInchDevPortalCrossChainPrivateProxyAdapter.prototype, "getTokenPrice", null);
//# sourceMappingURL=one-inch-dev-portal-cross-chain-private-proxy.adapter.js.map